{
  "title": "Reverse Gravity",
  "source": "Player's Handbook",
  "levelAndSchool": "7th-level transmutation",
  "level": 7,
  "castingTime": "1 action",
  "range": "100 feet",
  "components": "V, S, M (a lodestone and iron filings)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "This spell reverses gravity in a 50-foot-radius, 100-foot high cylinder centered on a point within range. All creatures and objects that aren’t somehow anchored to the ground in the area fall upward and reach the top of the area when you cast this spell. A creature can make a Dexterity saving throw to grab onto a fixed object it can reach, thus avoiding the fall.",
    "If some solid object (such as a ceiling) is encountered in this fall, falling objects and creatures strike it just as they would during a normal downward fall. If an object or creature reaches the top of the area without striking anything, it remains there, oscillating slightly, for the duration.",
    "At the end of the duration, affected objects and creatures fall back down."
  ],
  "spellLists": ["druid", "sorcerer", "wizard"]
}
